<script setup>
import { useToastStore } from '@/stores/toast.js'

const toastStore = useToastStore()

const getToastClasses = (type) => {
  const baseClasses = 'px-4 py-3 rounded-lg shadow-lg border-l-4 flex items-center justify-between min-w-80 max-w-md'
  
  switch (type) {
    case 'success':
      return `${baseClasses} bg-green-50 border-green-400 text-green-800`
    case 'error':
      return `${baseClasses} bg-red-50 border-red-400 text-red-800`
    case 'warning':
      return `${baseClasses} bg-yellow-50 border-yellow-400 text-yellow-800`
    case 'info':
    default:
      return `${baseClasses} bg-blue-50 border-blue-400 text-blue-800`
  }
}

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return '✓'
    case 'error':
      return '✕'
    case 'warning':
      return '⚠'
    case 'info':
    default:
      return 'ℹ'
  }
}
</script>

<template>
  <div class="fixed top-4 right-4 z-50 flex flex-col gap-6">
    <transition-group name="toast" tag="div">
      <div
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :class="getToastClasses(toast.type)"
        class="mb-2"
      >
        <div class="flex items-center">
          <span class="text-lg mr-3">{{ getIcon(toast.type) }}</span>
          <span class="text-sm font-medium">{{ toast.message }}</span>
        </div>
        <button
          @click="toastStore.removeToast(toast.id)"
          class="ml-4 text-lg hover:opacity-70 focus:outline-none"
        >
          ×
        </button>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>